import { useEffect, useRef } from 'react';
import { IPlatform, IPlugin } from '../../types';
import { Banner } from '../banner/banner.comp';
import { Faq } from '../faq/faq.comp';
import { Testimonials } from '../testimonials/testimonials.comp';
import { StyledEmbedPricing } from './pricing.styles';

require('@commonninja/commonninja-auth-sdk');

export const Pricing = ({
	widget,
	platform,
}: {
	widget?: IPlugin;
	platform?: IPlatform;
}) => {
	const pricingRef = useRef() as any;

	useEffect(() => {
		if (typeof window !== 'undefined') {
			// @ts-ignore
			window.CommonninjaAuthSDK.baseUrl = 'https://www.commoninja.com';
			// @ts-ignore
			window.CommonninjaAuthSDK.embedDashboardView(
				pricingRef?.current,
				`website/pricing/bracketsninja?via=brackets`
			);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			<>
				<StyledEmbedPricing
					className={`embedded-pricing`}
					ref={pricingRef}
				></StyledEmbedPricing>
				<Testimonials mode="light" />
				<Faq faqs={faqs} />
				<Banner
					title="Need a Custom Plan?"
					text={`If none of the premium plans we offer is enough for you - worry not! Contact us at contact@commoninja.com and we'll do our best to offer you a custom tailored plan.`}
					buttonText="Contact Us"
					buttonLink="https://www.commoninja.com/contact-form/lp/787c08f9-f4e7-4bc5-8906-3fbe99032d65"
					openInNewWindow={true}
				/>
			</>
		</>
	);
};

const faqs = [
	{
		q: 'Can I cancel my subscription?',
		a: 'Yes, you can cancel your subscription at any time.',
	},

	{
		q: 'How do I cancel my subscription?',
		a: 'To cancel your subscription, go to your Common Ninja dashboard, and choose the “Billing” tab. From there, find the app you want to cancel the subscription to and click “Cancel”.',
	},

	{
		q: ' What happens when I cancel my subscription?',
		a: 'After you cancel your subscription, you will still be able to continue using the app till the end of the month that you paid for.',
	},
	{
		q: 'What happens when my subscription expires',
		a: 'You can still use the app, but it will revert to the free plan cancelling all premium features.',
	},
	{
		q: 'Can I upgrade my plan?',
		a: 'Of course! We encourage you to! Choose the app you want to upgrade, and in its pricing page, choose the “Switch Plan” button under the plan you want to change to.',
	},

	{
		q: 'Can I downgrade my plan? ',
		a: 'Yes, you can. Choose the app you want to downgrade, and in its pricing page, choose the “Switch Plan” button under the plan you want to change to.',
	},
	{
		q: 'What happens if I downgrade my plan? ',
		a: 'Depending on your plan, the number of views and some features will become more limited or unavailable.',
	},

	{
		q: 'Can I have a customized plan?',
		a: ' Certainly! We aim to cater to all our users’ needs! Contact us and let us create a tailored plan just for you. ',
	},
	{
		q: 'Is my subscription renewed automatically? ',
		a: 'Yes. You can, however, cancel it whenever you like.',
	},

	{
		q: ' Does the plan price include VAT?',
		a: ' Yes, the price you see already includes VAT. ',
	},

	{
		q: 'I deleted Common Ninja’s app, why am I still being charged?',
		a: 'Deleting the app does not cancel the subscription. To cancel the subscription, you need to go to your Common Ninja dashboard, and choose the “Billing” tab. From here, find the app you want to cancel the subscription to and click “Cancel”.',
	},

	{
		q: 'Will I be refunded if I cancel before the end of the month?',
		a: 'You can check our refund policy here. You will, however, be able to continue using the app till the end of the month you paid for.',
	},

	{
		q: 'How do I update my payment details?',
		a: 'To update your payment details, contact our support team at support@commoninja.com and we will be happy to help you.',
	},

	{
		q: 'I have several apps, do I have to upgrade each one individually?',
		a: 'Yes. Each app has different features and therefore has a different pricing plan.',
	},
	{
		q: 'I’m switching to a new platform, do I need to cancel my subscription?',
		a: 'No. You can keep using Common Ninja’s apps on any new platform. For platform specific guides, please refer to our Knowledge Base articles.',
	},
	{
		q: ' Can I try a Common Ninja app before purchasing?',
		a: ' Certainly! We have a free plan available for all our apps.',
	},
	{
		q: 'What payment methods does Common Ninja accept? ',
		a: 'We accept all major credit cards and payments through PayPall.',
	},
];
